import { render, staticRenderFns } from "./GRadioButtonEx.vue?vue&type=template&id=dcc9791e&"
import script from "./GRadioButtonEx.vue?vue&type=script&lang=ts&"
export * from "./GRadioButtonEx.vue?vue&type=script&lang=ts&"
import style0 from "./GRadioButtonEx.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports